import React, { useState, useEffect } from "react";
import NavBar from '../components/NavBar';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux"
import { ethers } from "ethers";
import { Form } from "react-bootstrap";
import { CircularProgress } from "@mui/material";

import nftContract from "../artifacts/LION.sol/LION.json";
import { nftContractAddresses, ownerAddress, networkDeployedToes, multicallAddresses } from "../utils/contracts-config";
import { toast } from 'react-hot-toast'
import { useAccount, useNetwork } from 'wagmi'
import { readContract, writeContract } from '@wagmi/core'
import { waitForTransaction } from '@wagmi/core'
import multiCallAbi from "../artifacts/multiCallAbi.json";
import { config } from '../config.jsx';

const Dashboard = () => {
    let navigate = useNavigate();
    const { address, chainId } = useAccount()
    const data = useSelector((state) => state.blockchain.value)
    const [appInfo, setAppInfo] = useState({
        nftContractBalance: 0,
        nftContractPaused: 1,
        maxMintAmountPerTx: 5,
        mintCost: 0
    })

    const [loading, setLoading] = useState(false)

    let multicallAddress = chainId === 11155111 ? multicallAddresses[0] : multicallAddresses[1]
    let nftContractAddress = chainId === 11155111 ? nftContractAddresses[0] : nftContractAddresses[1]
    let networkDeployedTo = chainId === 11155111 ? networkDeployedToes[0] : networkDeployedToes[1]

    async function getAppInfo() {
        if (ownerAddress !== address) {
            navigate("/")
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        const AllInfo = await readContract({
            address: multicallAddress,
            abi: multiCallAbi,
            functionName: 'AllInfo',
            args: [address]
        })
        const ispaused = AllInfo[3]
        const _fee = AllInfo[5]
        const balance = await provider.getBalance(nftContractAddress);
        const _maxMintAmount = AllInfo[4]

        setAppInfo({
            nftContractBalance: Number(ethers.utils.formatUnits(balance, "ether")),
            nftContractPaused: Number(ispaused),
            maxMintAmountPerTx: _maxMintAmount,
            mintCost: Number(ethers.utils.formatUnits(_fee, "ether")),
        })

    }

    async function changeMintCost() {
        try {
            setLoading(true)
            const setContract = await writeContract({
                address: nftContractAddress,
                abi: nftContract.abi,
                functionName: 'setCost',
                args: [
                    ethers.utils.parseEther(String(appInfo.mintCost), "ether")
                ]
            })
            await waitForTransaction(config, {
                hash: setContract.hash
            })
            setLoading(false)
            toast.success('It was set up successfully')
        } catch (error) {
            setLoading(false)
            toast.error('There is some problem. Please try again later')
            console.log(error)
        }
    }

    async function changeMintAmount() {
        try {
            setLoading(true)
            const setContract = await writeContract({
                address: nftContractAddress,
                abi: nftContract.abi,
                functionName: 'setMaxMintAmountPerTx',
                args: [
                    appInfo.maxMintAmountPerTx
                ]
            })
            await waitForTransaction(config, {
                hash: setContract.hash
            })
            setLoading(false)
            toast.success('It was set up successfully')
        } catch (error) {
            setLoading(false)
            toast.error('There is some problem. Please try again later')
            console.log(error)
        }
    }

    async function withdraw() {
        try {
            setLoading(true)
            const setContract = await writeContract({
                address: nftContractAddress,
                abi: nftContract.abi,
                functionName: 'withdraw'
            })
            await waitForTransaction(config, {
                hash: setContract.hash
            })
            setLoading(false)
            toast.success('It was set up successfully')
        } catch (error) {
            setLoading(false)
            toast.error('There is some problem. Please try again later')
            console.log(error)
        }
    }

    async function changeContractState() {
        if (appInfo.nftContractPaused === 1) {
            try {
                setLoading(true)
                const setContract = await writeContract({
                    address: nftContractAddress,
                    abi: nftContract.abi,
                    functionName: 'pause',
                    args: [
                        '2'
                    ]
                })
                await waitForTransaction(config, {
                    hash: setContract.hash
                })
                setLoading(false)
                toast.success('It was set up successfully')
            } catch (error) {
                setLoading(false)
                toast.error('There is some problem. Please try again later')
                console.log(error)
            }
        } else {
            try {
                setLoading(true)
                const setContract = await writeContract({
                    address: nftContractAddress,
                    abi: nftContract.abi,
                    functionName: 'pause',
                    args: [
                        '1'
                    ]
                })
                await waitForTransaction(config, {
                    hash: setContract.hash
                })
                setLoading(false)
                toast.success('It was set up successfully')
            } catch (error) {
                setLoading(false)
                toast.error('There is some problem. Please try again later')
                console.log(error)
            }
        }
    }

    useEffect(() => {
        if (window.ethereum !== undefined) {
            getAppInfo()
        }
    }, [address])

    return (
        <section className='hero'>
            <NavBar />
            <br />
            <div className="dashboard-section">
                <h1 className="text-center" style={{ paddingTop: "30px" }}>
                    Owner Dashboard
                </h1>
                <div className="dashboard-container">
                    <div className="dashboard-content">
                        <div className='dashboard-row' >
                            <div className='dashboard-left'>
                                <label>Current contract balance : {appInfo.nftContractBalance} ETH</label>
                            </div>
                            <div className='dashboard-button-up'>
                                <button className='btn btn-info activeButton' onClick={withdraw}>
                                    {loading ? <CircularProgress color="inherit" size={18} /> : "withdraw"}
                                </button>
                            </div>
                        </div>
                        <br />
                        <div className='dashboard-row'>
                            <div className='dashboard-left'>
                                <label>Max NFT minted per transaction : </label>
                                <Form.Control type="Number"
                                    value={appInfo.maxMintAmountPerTx}
                                    onChange={(e) => setAppInfo({ ...appInfo, maxMintAmountPerTx: e.target.value })}
                                />
                            </div>
                            <div className='dashboard-button' >
                                <button className='btn btn-info activeButton' onClick={changeMintAmount}>
                                    {loading ? <CircularProgress color="inherit" size={18} /> : "Change"}
                                </button>
                            </div>
                        </div>
                        <br />
                        <div className='dashboard-row'>
                            <div className='dashboard-left'>
                                <label>NFT mint cost (ETH) : </label>
                                <Form.Control type="Number"
                                    value={appInfo.mintCost}
                                    onChange={(e) => setAppInfo({ ...appInfo, mintCost: e.target.value })}
                                />
                            </div>
                            <div className='dashboard-button' >
                                <button className='btn btn-info activeButton' onClick={changeMintCost}>
                                    {loading ? <CircularProgress color="inherit" size={18} /> : "Change"}
                                </button>
                            </div>
                        </div>
                        <br />
                        <br />
                        <div className='dashboard-row'>
                            <div className='dashboard-left'>
                                <label>
                                    {appInfo.nftContractPaused == 1 ? (
                                        "Nft Contract is paused"
                                    ) : (
                                        "Nft Contract is active"
                                    )}
                                </label>
                            </div>
                            <div className='dashboard-button-up'>
                                <button className='btn btn-info activeButton' onClick={changeContractState}>
                                    {appInfo.nftContractPaused === 1 ? (
                                        loading ? <CircularProgress color="inherit" size={18} /> : "Activate"
                                    ) : (
                                        loading ? <CircularProgress color="inherit" size={18} /> : "Pause"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Dashboard;
